import { createContext } from "react";
import type { CampaignOpening } from "@/shared/types/featureTeasing.types";

type Reservation = {
  campaignId: string
  uuid: string
  pending?: Promise<CampaignOpening>
};

export type CampaignVisitState = {
  present: (opening: CampaignOpening, returnFocus?: HTMLElement | null) => void
  beginManual: () => boolean
  endManual: () => void
  close: () => void
  consumed: boolean
  reservation?: Reservation
};

export const CampaignVisitContext = createContext<CampaignVisitState | null>(null);
